export const PRODUCT_QUERY_LIMIT = 20;

export const TABLE_COLUMNS = [
  {
    key: "id",
    accessor: "imageUrl",
    Header: () => null,
    width: 52,
    dataKey: "image"
  },
  {
    key: "name",
    accessor: "name",
    Header: "Product Name",
    width: 260
  },
  {
    key: "amount",
    accessor: "price",
    Header: "Price"
  },
  {
    key: "status",
    accessor: "totalSales",
    Header: "Sales Made"
  },
  {
    key: "status",
    accessor: "totalRevenue",
    Header: "Sales Earnings"
  },
  {
    key: "status",
    accessor: "createdAt",
    Header: "Date Created",
    width: 180
  },
  {
    Header: () => null, // No header
    id: "expander",
    width: 140
  }
];
